import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ContextMenu, Item } from '@Components/Common/ContextMenu';
import TX from '@Components/Common/Text';

import { ReactComponent as GoToSVG } from '@Assets/Svgs/ic_goto.svg';

const ItemContextMenu = ({ offsetSize, processIds, handleContextMenuItemClick }) => {
  const { top, left } = offsetSize;

  return (
    <ContextMenu position={{ top: top + 32, left }}>
      {processIds.map(id => (
        <Item key={`processId_${id}`} onClick={() => handleContextMenuItemClick(id)}>
          <ProcessIdText>P. {id}</ProcessIdText>
          <GoToIcon />
        </Item>
      ))}
    </ContextMenu>
  );
};

ItemContextMenu.propTypes = {
  offsetSize: PropTypes.objectOf(PropTypes.number).isRequired,
  processIds: PropTypes.arrayOf(PropTypes.number),
  handleContextMenuItemClick: PropTypes.func.isRequired,
};

ItemContextMenu.defaultProps = {
  processIds: [],
};

const ProcessIdText = styled(TX.FootnoteM)`
  flex: 1;
`;

const GoToIcon = styled(GoToSVG)`
  width: 16px;
  height: 16px;
`;

export default ItemContextMenu;
